"use strict";
exports.__esModule = true;
exports.Checkbox = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importDefault(require("react"));
function Checkbox(props) {
    var label = props.label, labelPlacement = props.labelPlacement, _a = props.checkboxPlacement, checkboxPlacement = _a === void 0 ? 'top' : _a, rest = tslib_1.__rest(props, ["label", "labelPlacement", "checkboxPlacement"]);
    var useClasses = core_1.makeStyles(function () {
        return core_1.createStyles({
            labelRoot: {
                marginLeft: 0,
                marginRight: 0
            },
            input: {
                alignSelf: checkboxPlacement === 'top'
                    ? 'flex-start'
                    : checkboxPlacement === 'bottom'
                        ? 'flex-end'
                        : ''
            }
        });
    });
    var classes = useClasses();
    return (react_1["default"].createElement(core_1.FormControlLabel, { classes: { root: classes.labelRoot }, control: react_1["default"].createElement(core_1.Checkbox, tslib_1.__assign({ className: classes.input }, rest)), label: label, labelPlacement: labelPlacement }));
}
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map